//首页
import React from 'react'
import { Card ,Col, Row,Image,Typography,Divider} from 'antd'
import './index.css'
import {

  ProjectOutlined,
  FundViewOutlined,
  HomeOutlined,
  PhoneOutlined,
  PrinterOutlined,
  MailOutlined 
} from '@ant-design/icons';
const { Title } = Typography;
export default function Home() {

  return (
    <Card type="ncenter" >
      <Row>
      <Col align='justify' span={24} offset={0}><Card  style={{ marginTop: 16}}
        type="inner" >
          <Row>
          <Col span={10} offset={0}>
          <Title></Title>
        </Col>
        </Row>
        <Row>
        <Col span={6} offset={0}><Image
          width={200}
          src={require('../../img/photo.jpg')}
        /></Col>
        <Col span={10} offset={0}>
        <Title>Dr. Ying (Gina) Tang</Title>
        <Title level={4}> Professor & Associate Chair</Title>
        <Title level={5}> <a href='https://engineering.rowan.edu/'>Department of Electrical & Computer Engineering</a></Title>
        <Title level={5}> <PhoneOutlined /> Phone: <a href='tel:+18562565339'>(856) 256-5339 </a>/ <PrinterOutlined /> Fax: <a href='tel:+18562565241'>(856)-256-5241</a></Title>
        <Title level={5}> <MailOutlined /> E-mail: <a href='mailto:tang@rowan.edu'>tang@rowan.edu</a></Title>

        
        </Col>
        </Row>
        <p/>
        <Divider />
        <h4>
          
        Ying (Gina) Tang is Professor of Electrical and Computer Engineering at Rowan University, Glassboro, New Jersey. Her research centers on the design, control, and optimization of discrete event systems (DES) with respect to their complexity, uncertainty and performance via mathematical modeling, statistical analysis, and computational visualization. Her current work involves two major thrust areas. One is Intelligent Game-based Learning Environments, where machine learning and adaptive reasoning techniques are fused with mixed reality technologies to offer personalized guided training. The other is Sustainable Production and Service Automation, where efficient models and algorithms are designed to help align manufacturers’/service providers’ decisions with environmental considerations (e.g., energy consumption and electronic waste, etc.) at every stage of the entire life cycle of products from the conceptual design to delivery to consumers, and ultimately to the end-of-life disposal. Tang’s work has been continuously supported by NSF, EPA, DOT, private foundations, and industry. Her work has resulted in two patents, and over 200 scientific publications.
        </h4>
        <p/>
        <h4>
        Tang is very active in professional services. She is VP Finance of the IEEE Systems, Man & Cybernetics Society (SMCS). She is the funding chair of Technical Committee (TC) on Intelligent Systems to Human-Aware Sustainability of SMCS and led the TC to win SMCS Most Active TC in 2021. She is also the funding chair of IEEE Robotic and Automation Society (RAS) Technical Committee on Sustainable Production Automation and led the TC to win the RAS CERMA project and the RAS Most Active TC in 2020. Currently she is Associate Editor for IEEE Transactions on Systems, Man & Cybernetics: Systems, IEEE Transactions on Computational Social Systems, and Discover Artificial Intelligence, and Editorial Board Member of International Journal of Remanufacturing. She is Guest Editor for the special section on Cyber-physical Social Intelligence Metaverse in CPSS in IEEE SMC: Systems, for the special Issue on Behavioral Modeling, Learning, and Adaptation in Cyber-physical Social Intelligence in IEEE Transactions on Computational Social Systems.
        </h4> 
        
  
        </Card></Col>
      </Row>
  </Card>

  )
    
  
}
